<template>
  <v-data-table
    :items-per-page="50"
    :headers="headers.filter(h => h.show === undefined || h.show())"
    :items="items"
    :items-length="items.length"
    :loading="loading"
    density="comfortable"
    :hide-default-footer="true"
    hover
    multi-sort
    color="primary"
  >
    <template #[`item.price`]="{ item: row }">
      {{ $formatters.currency(row.price) }}
    </template>
    <template #[`item.gross_revenue`]="{ item: row }">
      {{ $formatters.currency(row.revenue) }}
    </template>
    <template #[`item.revenue`]="{ item: row }">
      {{ $formatters.currency(row.revenue - row.discounts) }}
    </template>
    <template #[`item.discounts`]="{ item: row }">
      {{ $formatters.currency(row.discounts) }}
    </template>
    <template #[`item.fees`]="{ item: row }">
      {{ $formatters.currency(row.fees) }}
    </template>
    <template #body.append>
      <tr>
        <td class="font-weight-bold">
          Total
        </td>
        <td />
        <td />
        <td />
        <td />
        <td class="v-data-table-column--align-center font-weight-bold">
          {{ items.reduce((acc, i) => acc + i.count, 0) }}
        </td>
        <td />
        <td class="v-data-table-column--align-end font-weight-bold">
          {{
            $formatters.currency(
              items.reduce((acc, i) => acc + i.revenue, 0)
            )
          }}
        </td>
        <td class="v-data-table-column--align-end font-weight-bold">
          {{
            $formatters.currency(
              items.reduce((acc, i) => acc + i.discounts, 0)
            )
          }}
        </td>
        <td class="v-data-table-column--align-end font-weight-bold">
          {{
            $formatters.currency(
              items.reduce((acc, i) => acc + i.revenue - i.discounts, 0)
            )
          }}
        </td>
        <td v-if="can('read', 'fees')" class="v-data-table-column--align-end font-weight-bold">
          {{
            $formatters.currency(
              items.reduce((acc, i) => acc + i.fees, 0)
            )
          }}
        </td>
      </tr>
    </template>
    <template #bottom />
  </v-data-table>
</template>

<script lang="ts" setup>
import { DataTableHeader } from '@/types/DataTable'
import RevenueRecord from '@/types/RevenueRecord'
import { useAbility } from '@casl/vue'
import { Ref, ref } from 'vue'

const { can } = useAbility()

const headers: Ref<DataTableHeader[]> = ref([
  { title: 'Setor', value: 'sector', key: 'sector', sortable: true },
  { title: 'Tipo', value: 'type', key: 'type', sortable: true },
  { title: 'Lote', value: 'batch', key: 'batch', sortable: true, align: 'center' },
  { title: 'Forma de Pagamento', value: 'payment_method', key: 'payment_method', sortable: true, align: 'center' },
  { title: 'Parcelamento', value: 'installments', key: 'installments', sortable: true, align: 'center' },
  { title: 'Ingressos', value: 'count', key: 'count', sortable: false, align: 'center' },
  { title: 'Valor Unitário', value: 'price', key: 'price', sortable: false, align: 'center' },
  { title: 'Valor Bruto', value: 'gross_revenue', key: 'gross_revenue', sortable: false, align: 'end' },
  { title: 'Descontos', value: 'discounts', key: 'discounts', sortable: false, align: 'end' },
  { title: 'Receita', value: 'revenue', key: 'revenue', sortable: false, align: 'end' },
  { title: 'Taxas de Serviço', value: 'fees', key: 'fees', sortable: false, align: 'end', show: () => can('read', 'fees') },
])

interface Props {
  items: RevenueRecord[]
  loading: boolean
}

const { items, loading } = defineProps<Props>()
</script>
